import type { FileRejection } from 'react-dropzone';

import type { FileInputRejection, FileRejectionReason } from './types';

const REJECTION_REASONS: Record<string, FileRejectionReason> = {
  'file-invalid-type': 'invalid-type',
  'file-too-large': 'too-large',
  'file-too-small': 'too-small',
  'too-many-files': 'too-many-files',
};

/**
 * Lists the accepted extensions the way the instructions read them — "any one
 * of these", so a disjunction (".docx or .pdf") rather than a conjunction.
 */
export function resolveFileTypeList(
  accept: Record<string, string[]>,
  locale: string,
) {
  const extensions = [...new Set(Object.values(accept).flat())];

  if (extensions.length === 0) {
    return undefined;
  }

  return new Intl.ListFormat(locale, { type: 'disjunction' }).format(
    extensions,
  );
}

/** Restates dropzone's error codes as the reasons this package documents. */
export function toFileInputRejections(
  rejections: FileRejection[],
): FileInputRejection[] {
  return rejections.map(({ errors, file }) => ({
    file,
    reasons: [
      ...new Set(
        errors.map(({ code }) => REJECTION_REASONS[code] ?? 'unknown'),
      ),
    ],
  }));
}
